(()=>{
  const expanded=new Map();
  let pending=false;
  function enhance(){
    document.querySelectorAll('variant-selects [data-zb-options]').forEach(group=>{
      const inputs=Array.from(group.querySelectorAll('input[type="radio"]'));
      if(inputs.length<=6)return;
      const picker=group.closest('variant-selects');
      const key=picker.dataset.productId+':'+inputs[0].name;
      let button=group.querySelector('[data-zb-options-toggle]');
      if(!button){button=document.createElement('button');button.type='button';button.className='zb-options-toggle';button.dataset.zbOptionsToggle=key;group.append(button);}
      const showAll=expanded.get(key)===true;
      inputs.forEach((input,index)=>{const hide=!showAll&&index>=6&&!input.checked;input.hidden=hide;const label=input.nextElementSibling;if(label?.tagName==='LABEL'){label.hidden=hide;label.classList.add('zb-option-card');}});
      button.textContent=showAll?group.dataset.showLess:group.dataset.showAll;
      button.setAttribute('aria-expanded',String(showAll));
    });
  }
  function schedule(){if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;enhance();});}
  document.addEventListener('click',event=>{const button=event.target.closest('[data-zb-options-toggle]');if(!button)return;expanded.set(button.dataset.zbOptionsToggle,button.getAttribute('aria-expanded')!=='true');enhance();});
  document.addEventListener('change',event=>{if(event.target.closest('variant-selects'))schedule();});
  const scope=document.querySelector('main');if(scope)new MutationObserver(records=>{if(records.some(r=>Array.from(r.addedNodes).some(n=>n.nodeType===1&&(n.matches('variant-selects,[data-zb-options]')||n.querySelector('variant-selects,[data-zb-options]')))))schedule();}).observe(scope,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',schedule);
  enhance();
})();
